<template>
  <el-dialog
    class="change-class-dialog"
    :title="title"
    :visible.sync="visible"
    :width="width"
    :append-to-body="true"
    :before-close="emitClose"
    :close-on-click-modal="closeOnClickModal"
    :close-on-press-escape="closeOnPressEscape"
    :showClose="showClose">
    <div class="content">
      将以下 {{ students.length }} 名学生转至：
      <grade-class :org-id="orgId" ref="gradeClass"
        :class-id="classId"
        :init-selected="visible"
        @grade-class-change="handleGradeClassChange" />
      <div class="students">
        <div v-for="(student, index) in students" :key="index" class="student" :title="student.studentname">
          {{ student.studentname }}
        </div>
      </div>
    </div>
    <span slot="footer">
      <el-button type="success" @click="confirm" :loading="confirmLoading">确 定</el-button>
      <el-button type="info" @click="emitClose" :disabled="cancelDisabled">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  querySchoolClasses,
  changeClass
} from '@/model/info-model'
import GradeClass from '@/components/custom/GradeClass'

export default {
  name: 'ChangeClassDialog',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    orgId: { // 当前机构的 orgId
      type: String,
      required: true
    },
    students: { // 待转班的学生
      type: Array,
      default () {
        return [{}]
      }
    },
    title: {
      type: String,
      default: '转班'
    },
    width: { // 弹窗的宽(http://element-cn.eleme.io/#/zh-CN/component/dialog)
      type: String,
      default: '560px'
    },
    classId: {
      type: String
    }
  },
  data () {
    return {
      // [ gradeid, classcode ]
      // [ 10, '2' ]: 高一2班
      selectedClass: [],
      closeOnClickModal: true,
      closeOnPressEscape: true,
      showClose: true,
      confirmLoading: false,
      cancelDisabled: false
    }
  },
  computed: {
    studentIds () {
      let ids = []
      this.students.forEach(v => ids.push(v.studentid))
      return ids
    },
    classTo () {
      return {
        // 注意：这里应该是 `gradid`, 不是 `gradeid`(应该是原来后端把单词写错了)
        gradid: this.selectedClass[0].toString(),
        classcode: this.selectedClass[1]
      }
    }
  },
  methods: {
    enableDialogOperation () {
      this.closeOnClickModal = true
      this.closeOnPressEscape = true
      this.showClose = true
      this.confirmLoading = false
      this.cancelDisabled = false
    },
    disableDialogOperation () {
      this.closeOnClickModal = false
      this.closeOnPressEscape = false
      this.showClose = false
      this.confirmLoading = true
      this.cancelDisabled = true
    },
    querySchoolClasses () {
      return querySchoolClasses({ orgid: this.orgId })
    },
    changeClass () {
      return changeClass({
        orgid: this.orgId,
        studentid: this.studentIds,
        classto: this.classTo
      })
    },
    handleGradeClassChange (value) {
      this.selectedClass = value
    },
    emitClose () {
      this.$emit('change-class-dialog-close')
    },
    confirm () {
      console.log(this.selectedClass)
      if (this.selectedClass.length !== 2) {
        return
      }
      // this.$emit('change-class-dialog-confirm', this.selectedClass)
      this.disableDialogOperation()
      this.changeClass().then(res => {
        console.log(res)
        if (res.result === 'true') {
          this.$message.success('转班成功！')
          this.$emit('change-class-dialog-confirm', {
            selectedClass: this.selectedClass,
            changeSuccess: true
          })
        } else {
          this.$message.error('转班失败！')
        }
        this.enableDialogOperation()
      }).catch(e => {
        console.log(e)
        this.$message.error('转班失败！')
        this.enableDialogOperation()
      })
    }
  },
  components: {
    GradeClass
  }
}
</script>

<style lang="scss">
.change-class-dialog {
  .students {
    border: 1px solid #ccc;
    margin-top: 25px;
    min-height: 172px;
    max-height: 342px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
  }
  .student {
    box-sizing: border-box;
    width: 100px;
    padding: 5px 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/class/ChangeClassDialog.vue